module.exports = __webpack_public_path__ + "media/images/flags/1x1/tkl-c260139f051a7ef8554228d5fe75bea7.svg";